var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD513",
    d: "M14.68 0a14.7 14.7 0 0 0-8.16 2.484 14.715 14.715 0 0 0-2.213 22.621 14.69 14.69 0 0 0 16.01 3.182 14.7 14.7 0 0 0 6.593-5.415 14.7 14.7 0 0 0 2.475-8.168A14.73 14.73 0 0 0 25.07 4.309 14.7 14.7 0 0 0 14.68 0"
  })));
};
export default SvgLogo;